import { Box, IconButton, styled } from '@mui/material';

export const CodeBlockContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#000',
  position: 'relative',
  borderRadius: theme.border.radius2,
  overflow: 'auto',
  padding: theme.spacing(2),

  pre: {
    margin: 0,
    border: '0px',

    code: {
      fontFamily: theme.typography.snippet.fontFamily,
      fontSize: '.7rem',
      lineHeight: 1.5,
      backgroundColor: 'transparent',
      color: theme.palette.code.white,

      '.hljs-attr': {
        color: theme.palette.code.text,
      },
      '.hljs-number': {
        color: theme.palette.code.green,
      },
      '.hljs-punctuation': {
        color: theme.palette.code.white,
      },
      '.hljs-string': {
        color: theme.palette.code.orange,
      },
    },
  },
}));

export const Header = styled('div')(({ theme }) => ({
  color: theme.palette.code.text,
  '.MuiTypography-root': {
    display: 'inline-block',
    fontSize: theme.typography.caption.fontSize,
    padding: theme.spacing(1, 2),
    fontFamily: theme.typography.bold.fontFamily,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
}));

export const CopyButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  color: theme.palette.code.white,
  padding: theme.spacing(1),

  '&:hover': {
    color: theme.palette.primary.main,
  },

  span: {
    fontFamily: theme.typography.bold.fontFamily,
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.success.main,
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginLeft: theme.spacing(0.5),
    },
  },
}));
